import * as React from "react";
import RowCheckbox from "components/common/EntityDataTable/RowCheckbox";
import useSelectedMessageEntities from "views/hooks/useSelectedMessageEntities";
export const BulkSelectHead = ({ data }) => {
  const { toggleAllEntitySelect, isAllRowsSelected, isSomeRowsSelected } = useSelectedMessageEntities();
  const title = `${isAllRowsSelected ? "Deselect" : "Select"} all uploaded messages`;
  const onBulkSelect = () => {
    toggleAllEntitySelect(data);
  };
  return /* @__PURE__ */ React.createElement(
    RowCheckbox,
    {
      indeterminate: isSomeRowsSelected,
      onChange: onBulkSelect,
      checked: isAllRowsSelected,
      title,
      disabled: !(data == null ? void 0 : data.length),
      "aria-label": title
    }
  );
};
export default BulkSelectHead;
